import {FETCH_LEGEND_REQUEST,FETCH_LEGEND_SUCCESS, FETCH_LEGEND_FAILURE} from "./legendTypes";


const initialState = {
  loading: true,
  data: [],
  errorMsg: "",
};

const LegendReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LEGEND_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_LEGEND_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        errorMsg: "",
      };
    case FETCH_LEGEND_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        errorMsg: action.payload,
    };
    default:
      return state;
  }
};

export default LegendReducer;
